/**
 * The calendar day a timestamp falls on, where the family is.
 *
 * A plan date is already a day ("2026-09-28") and is kept as it is. An evidence
 * timestamp is UTC, and slicing it would put a photo taken at 4am in Karachi on
 * the previous day, so it is converted to the device's own calendar first.
 */
export function localDay(value: string): string {
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value.slice(0, 10);
  const offset = date.getTimezoneOffset() * 60_000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 10);
}

/**
 * How many days in a row, ending today, something was recorded for this child.
 *
 * A day counts if an activity was ticked done or a piece of evidence was saved.
 * It used to count evidence alone, which meant a family ticking every activity
 * every day still read "0 day streak" — the app told the people doing the work
 * that they were not doing it.
 *
 * Today not being done yet must not break a real streak, so an empty today is
 * skipped once rather than ending the count.
 */
export function streakFrom(dates: string[], now = new Date()): number {
  const days = new Set(dates.map(localDay));
  const cursor = new Date(now.getTime());
  let streak = 0;
  for (let step = 0; step < 400; step += 1) {
    const key = localDay(cursor.toISOString());
    if (days.has(key)) streak += 1;
    else if (step > 0) break;
    cursor.setDate(cursor.getDate() - 1);
  }
  return streak;
}
